module.exports = __webpack_public_path__ + "static/media/YM72_5.dc9b7f04.jpg";